const weights = {
  // baseWeight: 0.13,
  // timeSlant: 0.18,
  // valueSlant: 0.2,
  // reverse: true,
  baseWeight: 0.0001,
  timeSlant: 1.2,
  valueSlant: 1.8,
};

export default weights;
